import OrderItem from './OrderItem.component';

export default OrderItem;